import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SubmarineQuestPrivacyPolicy from "./SubmarineQuestPrivacyPolicy";
import SubmarineQuestTOS from "./SubmarineQuestTOS";
import Home from "./Home";
import AccountRemoval from "./AccountRemoval";

// Static pages live in /public (served directly by Firebase with cleanUrls).
// In local dev (npm start) the dev server falls back to React, so hop to the .html file.
function StaticPage({ file }) {
  React.useEffect(() => {
    window.location.replace(`/${file}.html`);
  }, [file]);
  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page */}
        <Route path="/" element={<Home />} />

        {/* Privacy Policy page */}
        <Route path="/submarinequest-privacy" element={<SubmarineQuestPrivacyPolicy />} />

        {/* Terms of Service page */}
        <Route path="/submarinequest-tos" element={<SubmarineQuestTOS />} />
        <Route path="/account-removal" element={<AccountRemoval />} />

        {/* Submarine Quest game page (static HTML in /public) */}
        <Route path="/submarinequest" element={<StaticPage file="submarinequest" />} />
      </Routes>
    </Router>
  );
}

export default App;